const FLYWIRE_CALLBACK_URL = 'v0/orders/flywire/callback';

// Decode the url if it is encoded.
// eslint-disable-next-line import/prefer-default-export
export function decodeUrl(url) {
  try {
    return decodeURIComponent(url);
  }
  catch (err) {
    console.error('unable to decode url', url);
    return url;
  }
}

export function getGatewayUrl() {
  const origin = window?.location?.origin;

  if (!origin) {
    return null;
  }

  // Proxy to the Gateway using own domain
  return `${origin}/api`;
}

export function getFlywireCallbackUrl() {
  const gatewayUrl = getGatewayUrl();
  return `${gatewayUrl}/${FLYWIRE_CALLBACK_URL}`;
}
